<nav *ngIf="activeTab && (!isActivatedOnMobile || (isActivatedOnMobile && isMobile())) && !(hideTabBarIfOneTab && numberOfTabs === 1)" class="tabs" [ngClass]="customClasses">
	<a
		[attr.data-cy]="tab.title + ' tab' | slugify"
		*ngFor="let tab of tabs; index as i"
		href="#"
		class="tab text-16 d-inline-block hover-bold"
		[class.active]="activeTabIndex === i"
		[ngClass]="[type, 'tab-' + tabs.length]"
		(click)="activateTab(tab, $event)"
		[ngStyle]="type !== 'border-tab' && { width: hasFullWidth ? tabMaxWidth + '%' : 'auto', 'max-width': 'calc(' + tabMaxWidth + '% - 20px' }"
		[title]="tab.title"
		custom-tracking
		[track-event]="'nav-tab:' + tab.title"
	>
		<span class="icon-caption">{{ tab.title }}</span>
		<info-bubble class="text-12" [dcrKey]="tab.tooltip"></info-bubble>
	</a>
	<section *ngIf="showTabNavSeparator" class="tab-header-separator"></section>
</nav>
<div class="tab-content">
	<ng-container *ngIf="activeTab && (!isActivatedOnMobile || (isActivatedOnMobile && isMobile()))">
		<ng-container *ngTemplateOutlet="activeTab.templateRef"></ng-container>
	</ng-container>
	<section *ngIf="isActivatedOnMobile && !isMobile()" class="row margin-standard">
		<ng-container *ngFor="let tab of tabs"> <ng-container *ngTemplateOutlet="tab.templateRef"></ng-container> </ng-container>
	</section>
</div>
